<template>
  <div>
    <div class="spinner">
         <el-skeleton style="width: 100%" :loading="loading" animated>
          <template slot="template" v-if="quotation==0">
            <div class="spinner-title">
              <el-skeleton-item variant="h3" style="width: 15%; height: 20px; margin-left: 10px;" />
              <el-skeleton-item variant="h3" style="width: 10%; height: 20px; margin-left: 10px;" />
              <el-skeleton-item variant="h3" style="width: 15%; height: 20px; margin-left: 10px;" />
              <el-skeleton-item variant="h3" style="width: 10%; height: 20px; margin-left: 10px;" />
            </div>
            <div class="spinner-list" v-for="i in 7" :key="i">
              <div class="spinner-list-item">
                <el-skeleton-item variant="h3" style="width: 160px; height: 16px; margin-left: 10px; margin-top: 10px;" />
                <el-skeleton-item variant="h3" style="width: 100px; height: 10px; margin-left: 10px; margin-top: 10px;" />
                <el-skeleton-item variant="h3" style="width: 130px; height: 10px; margin-left: 10px; margin-top: 10px;" />
              </div>
              <div class="  spinner-list-item-right">
                <el-skeleton-item variant="h3" style="width: 80px; height: 80px; margin-left: 10px; margin-top: 10px;" />
                <div class="spinner-list-item">
                  <el-skeleton-item variant="h3" style="width: 160px; height: 16px; margin-left: 10px; margin-top: 10px;" />
                  <el-skeleton-item variant="h3" style="width: 100px; height: 10px; margin-left: 10px; margin-top: 20px;" />
                  <el-skeleton-item variant="h3" style="width: 130px; height: 10px; margin-left: 10px; margin-top: 10px;" />
                </div>
              </div>
              <div class="spinner-list-item">
                <el-skeleton-item variant="h3" style="width: 100px; height: 20px; margin-left: 30px; margin-top: 40px;" />
              </div>
              <div class="spinner-list-item" style="margin-left: 40px;">
                <el-skeleton-item variant="h3" style="width: 400px; height: 16px; margin-left: 10px; margin-top: 10px;" />
                <el-skeleton-item variant="h3" style="width: 200px; height: 10px; margin-left: 10px; margin-top: 10px;" />
                <el-skeleton-item variant="h3" style="width: 130px; height: 10px; margin-left: 10px; margin-top: 10px;" />
              </div>
            </div>
          </template>
          <template slot="template" v-if="quotation==1">
            <div class="spinner-title">
              <el-skeleton-item variant="h3" style="width: 15%; height: 20px; margin-left: 10px;" />
              <el-skeleton-item variant="h3" style="width: 10%; height: 20px; margin-left: 10px;" />
              <el-skeleton-item variant="h3" style="width: 15%; height: 20px; margin-left: 10px;" />
              <el-skeleton-item variant="h3" style="width: 10%; height: 20px; margin-left: 10px;" />
            </div>
            <div class="spinner-list" v-for="i in 7" :key="i">
              <div class="spinner-list-middle">
                <el-skeleton-item variant="h3" style="width: 140px; height: 16px; margin-left: 10px; " />
              </div>
              <div class="spinner-list-middle">
                <el-skeleton-item variant="h3" style="width: 120px; height: 16px; margin-left: 40px; " />
              </div>
              <div class="spinner-list-middle">
                <el-skeleton-item variant="h3" style="width: 160px; height: 16px; margin-left: 80px; " />
              </div>
              <div class="spinner-list-middle">
                <el-skeleton-item variant="h3" style="width: 120px; height: 16px; margin-left: 180px; " />
              </div>
              <div class="spinner-list-middle">
                <el-skeleton-item variant="h3" style="width: 80px; height: 16px; margin-left: 120px; " />
              </div>
              <div class="spinner-list-item" style="margin-left: 40px;">
                <el-skeleton-item variant="h3" style="width: 400px; height: 16px; margin-left: 10px; margin-top: 10px;" />
                <el-skeleton-item variant="h3" style="width: 200px; height: 10px; margin-left: 10px; margin-top: 10px;" />
                <el-skeleton-item variant="h3" style="width: 130px; height: 10px; margin-left: 10px; margin-top: 10px;" />
              </div>
              <div class="spinner-list-middle" style="margin-left: 24%">
                <el-skeleton-item variant="h3" style="width: 80px; height: 16px;  " />
              </div>
              <div class="spinner-list-middle" style="margin-left: 3%">
                <el-skeleton-item variant="h3" style="width: 80px; height: 16px;  " />
              </div>
            </div>
          </template>
         </el-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  components: {},
  props: {
    quotation: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading:true,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
 .spinner-title{
   width: 100%;
   height: 50px;
   display: flex;
   justify-content: left;
   align-items: center;
   background-color: #f7f7f9;
   margin-top: 10px;
 }
 .spinner-list{
  background-color: #fff;
  width: 100%;
  height:120px;
  display: flex;
  justify-content: left;
  border-bottom: 1px solid #eee;
 }
 .spinner-list-item{
  display: flex;
  flex-direction: column;
 }
 .spinner-list-item-right{
  display: flex;
 }
 .spinner-list-middle{
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
 }
</style>
